<script setup lang="ts">
import type { CmsElementSidebarFilter } from "@shopware/composables";
import SwProductListingFilters from "../../listing-filters/SwProductListingFilters.vue";

defineProps<{
  content: CmsElementSidebarFilter;
}>();

const showFilter = ref(false);

const toggleFilter = () => {
  showFilter.value = !showFilter.value;
};
</script>
<template>
    <SwProductListingFilters :content="content" />
</template>
